'use client';

import type React from 'react';
import ProfileObjectMobileCard from '@/features/ProfileObjectCard/Mobile/ProfileObjectMobileCard';
import SmallCard from '@/features/SmallCard/SmallCard';
import { useUser } from '@/forApp/states/userState/userState';
import LinkPagination from '@/shared/Pagination/LinkPagination';
import type { CatalogListCommonProps } from './CatalogListProfile';
import styles from './styles.module.css';

export type CatalogListMapProps = CatalogListCommonProps & {
  currentPage?: number;
  totalItems?: number;
  itemsPerPage?: number;
  basePath?: string;
  isMobile?: boolean;
};

const CatalogListMap: React.FC<CatalogListMapProps> = ({
  catalogList,
  typeObj,
  currentPage,
  totalItems,
  itemsPerPage,
  basePath,
  isMobile,
}) => {
  const { user } = useUser();

  if (!catalogList || catalogList.length === 0) {
    return (
      <div className={styles.emptyState}>
        <h3>Объекты не найдены</h3>
        <p>
          Попробуйте изменить параметры поиска или посмотрите другие разделы
          каталога.
        </p>
      </div>
    );
  }

  const canPaginate =
    typeof currentPage === 'number' &&
    typeof totalItems === 'number' &&
    typeof itemsPerPage === 'number' &&
    typeof basePath === 'string' &&
    Math.ceil(totalItems / itemsPerPage) > 1;

  return (
    <div>
      <div className={styles.itemListMap}>
        {catalogList.map((item, index) =>
          isMobile ? (
            <ProfileObjectMobileCard
              key={item.id || index}
              card={item}
              type="favorite"
              profile={user ? { role: user.role } : undefined}
              typeObj={typeObj}
            />
          ) : (
            <SmallCard
              key={item.id || index}
              card={item}
              type="favorite"
              profile={user ? { role: user.role } : undefined}
              typeObj={typeObj}
            />
          ),
        )}
      </div>

      {canPaginate ? (
        <LinkPagination
          currentPage={currentPage}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          basePath={basePath}
          maxVisiblePages={2}
        />
      ) : null}
    </div>
  );
};

export default CatalogListMap;
